import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button as Buttons } from '@telus-uds/components-web'
import ConfirmationBox from '../../design/shared/ConfirmationBox';

import request from '../../utils/request';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button,ButtonBox } from './css';

const CancelOrder = ({ orderData, fetchOrders }) => {
  const { id, isQuoteReference } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, cancel, cancelConfirmation },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancelOrder = () => {
    request.delete(`/orders/${id}`).then(() => {
      fetchOrders();
      setIsModalOpen(false);
    });
  };

  if (isQuoteReference) return null;

  return (
    <>
      <Button className="action-button" onClick={() => setIsModalOpen(true)}>
        {cancel}
      </Button>
      <ConfirmationBox
        open={isModalOpen}
        hideCloseButton={!isModalOpen}
        setOpen={() => isModalOpen}
        header={confirmationDialog}
        onClose={() => setIsModalOpen(false)}
      >
        <p style={{ fontSize: '15px', padding: '8px 0' }}>{cancelConfirmation}</p>
        <ButtonBox>
          <Buttons variant={{ priority: 'high', semantic: 'danger' }} onPress={handleCancelOrder} >Confirm</Buttons>
          <Buttons variant={{ priority: 'low' }} onPress={() => setIsModalOpen(false)}>cancel</Buttons>
        </ButtonBox>
      </ConfirmationBox>   
    
    </>
  );
};

CancelOrder.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default CancelOrder;
